import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

import faqContent from './faqContent';
import * as S from './styles';

const FAQ: React.FC = (): JSX.Element => {
  return (
    <S.Container>
      <S.Title>Dúvidas frequentes</S.Title>

      {faqContent.map(({ question, answer }) => (
        <Accordion key={question} sx={{ marginBottom: '2rem' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography
              sx={{ fontSize: '1.6rem', fontWeight: 600, textAlign: 'start' }}
            >
              {question}
            </Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Typography
              sx={{ fontSize: '1.6rem', color: '#565C66', textAlign: 'start' }}
            >
              {answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </S.Container>
  );
};

export default FAQ;
